import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetInternshipsPath } from '#/modules/search/internships/routing/searchGetInternshipsPath';
import { searchGetJobsPath } from '#/modules/search/jobs/routing/searchGetJobsPath';
import { searchGetOrgsPath } from '#/modules/search/orgs/routing/searchGetOrgsPath';

import type { FindAJobDropdownData } from './types/FindAJobDropdownData';

export const findAJobDropdownDataPt: FindAJobDropdownData = {
  search: {
    title: 'Busca',
    items: [
      {
        type: 'job',
        title: 'Empregos',
        href: searchGetJobsPath({
          locale: I18nLocale.PT,
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'internship',
        title: 'Estágios',
        href: searchGetInternshipsPath({ locale: I18nLocale.PT }),
      },
      {
        type: 'org',
        title: 'Organizações',
        href: searchGetOrgsPath({ locale: I18nLocale.PT }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [],
  },
};
